import * as React from "react";
import { Component, Fragment } from "react";
import RoundRobinTable from "../../tables/RoundRobinTable";
import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import CardTitle from "react-md/lib/Cards/CardTitle";
import getFromApi from "src/services/fetchService";
// import headToHeadRankings from "../../../fake-data/headToHeadRankings";
// import rplRankings from "../../../fake-data/rplRankings";

interface IState extends IHeadToHeadRankings {
  isLoaded: boolean;
}

class HeadToHeadRankings extends Component<{}, IState> {
  constructor(props: {}) {
    super(props);

    this.state = {
      isLoaded: false,
      tournamentTitle: "",
      tableLines: []
    };
  }

  async componentDidMount(): Promise<void> {
    // fetch(
    //   "https://football-predictions-v2.herokuapp.com/api/headtohead/tournaments/1/table"
    // )
    //   .then(results => results.json())
    //   .then(data => {
    //     this.setState({ tournamentTitle: data.tournamentTitle });
    //     this.setState({ tableLines: data.tableLines });
    //     this.setState({
    //       tableLines: this.state.tableLines.sort(line => line.points).reverse()
    //     });
    //     this.setState({ isLoaded: true });
    //   });

    let apiData: IHeadToHeadRankings = await getFromApi<IHeadToHeadRankings>(
      "https://football-predictions-v2.herokuapp.com/api/headtohead/tournaments/1/table"
    );

    this.setState({...apiData, isLoaded: true});
    // this.setState({isLoaded: true});
  }

  renderContent() {
    if (this.state.isLoaded) {
      return (
        <Card>
          <CardTitle title={this.state.tournamentTitle} />
          <CardText>
            <RoundRobinTable expertResults={this.state.tableLines} />
          </CardText>
        </Card>
      );
    } else {
      return (
        <Card>
          <CardTitle title="Получение данных..." />
        </Card>
      );
    }
  }

  render() {
    return <Fragment>{this.renderContent()}</Fragment>;
  }
}

export default HeadToHeadRankings;



// WEBPACK FOOTER //
// ./src/components/pages/tournament-rankings/HeadToHeadRankings.tsx